<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card" v-if="qpr">
              <form role="form" @submit.prevent="confirm">
                <div class="card-header pb-0">
                    <div class="d-flex justify-content-between">
                        <div class="d-grid gap-2 d-flex">
                            <button 
                                type="button"
                                class="btn btn-xs btn-outline-secondary text-xs font-weight-normal m-0" 
                                @click="edit = true"
                                v-if="!edit && qpr.state == 'QC Submitted'">
                                <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit
                            </button>
                            <template v-if="edit && qpr.state == 'QC Submitted'">
                                <button type="submit" :class="'btn btn-xs btn-primary text-xs font-weight-normal m-0 ' + (loading ? 'disabled' : '')">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                                    <i class="fa fa-check" aria-hidden="true" v-if="!loading"></i> 
                                    Confirm
                                </button>
                                <button type="button" @click="edit = false, getQPRDetail()" class="btn btn-xs btn-outline-secondary text-xs font-weight-normal m-0">
                                    <i class="fa fa-times" aria-hidden="true"></i> Discard
                                </button>
                            </template>
                            <button 
                              type="button"
                              @click="download"
                              :class="'btn btn-xs btn-outline-primary text-xs font-weight-normal m-0 ' + (loading ? 'disabled' : '')"
                              v-if="qpr.state === 'Vendor Confirmed' || qpr.state === 'Department Confirmed' || qpr.state === 'Validate'">
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                              <i class="fa fa-download" v-if="!loading"></i> Download
                            </button>
                        </div>
                        <div class="d-grid gap-2 d-flex">
                            <argon-badge color="secondary" class="text-xxs align-self-center">{{ qpr.state }}</argon-badge>
                        </div>
                    </div>
                    <hr/>
                </div>
                <div class="card-body pt-0 min-vh-50">
                    <h5>{{ qpr.name }}</h5>
                    <div class="row">
                        <div class="col-lg-4 col-md-6">
                            <table class="text-sm" width="100%">
                                <tbody>
                                    <!-- <tr>
                                        <td class="py-1 text-secondary" width="50%">Customer</td>
                                        <td class="py-1 font-weight-bold">{{ qpr.customer_name }}</td>
                                    </tr> -->
                                    <tr>
                                        <td class="py-1 text-secondary align-top">Product No</td>
                                        <td class="py-1 font-weight-bold">{{ qpr.product_code }}</td>
                                    </tr>
                                    <tr>
                                        <td class="py-1 text-secondary align-top">Product Name</td>
                                        <td class="py-1 font-weight-bold">{{ qpr.product_name }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <table class="text-sm" width="100%">
                                <tbody>
                                    <tr>
                                        <td class="py-1 text-secondary align-top" width="50%">Issue Date</td>
                                        <td class="py-1 font-weight-bold">{{ qpr.issue_date }}</td>
                                    </tr>
                                    <tr>
                                        <td class="py-1 text-secondary align-top">Find Place</td>
                                        <td class="py-1 font-weight-bold">{{ qpr.find_place }}</td>
                                    </tr>
                                    <tr>
                                        <td class="py-1 text-secondary align-top">Responsible Department</td>
                                        <td class="py-1 font-weight-bold">{{ qpr.department_name }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <table class="text-sm" width="100%">
                                <tbody>
                                    <tr>
                                        <td class="py-1 text-secondary align-top">Deadline Date</td>
                                        <td class="py-1 font-weight-bold">{{ qpr.deadline_date }}</td>
                                    </tr>
                                    <tr>
                                        <td class="py-1 text-secondary align-top" width="50%">Classification</td>
                                        <td class="py-1 font-weight-bold">
                                          <argon-badge 
                                            :variant="qpr.drawback_classification === 'FATAL' ? 'gradient' : ''" 
                                            :color="qpr.drawback_classification === 'FATAL' ? 'danger' : 
                                                    qpr.drawback_classification === 'HEAVY' ? 'warning' : 
                                                    qpr.drawback_classification === 'LIGHT' ? 'secondary' : ''"
                                            size="md">{{ qpr.drawback_classification }}</argon-badge>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row mt-3">
                      <p class="text-sm font-weight-bold mb-1">Defect Content and Status</p>
                      <div class="col-md-4">
                        <table class="text-sm" width="100%">
                            <tbody>
                                <tr>
                                    <td class="py-1 text-secondary" width="50%">Problem</td>
                                    <td class="py-1 font-weight-bold">{{ qpr.problem }}</td>
                                </tr>
                                <tr>
                                    <td class="py-1 text-secondary align-top">Standart</td>
                                    <td class="py-1 font-weight-bold">{{ qpr.product_code }}</td>
                                </tr>
                                <tr>
                                    <td class="py-1 text-secondary align-top">QTY</td>
                                    <td class="py-1 font-weight-bold">{{ qpr.defect_qty }} {{ qpr.uom_name }}</td>
                                </tr>
                            </tbody>
                        </table>
                      </div>
                      <div class="col-md-8">
                        <!-- <p class="text-sm font-weight-bold mb-1">Description</p> -->
                        <table class="text-sm" width="100%">
                            <tbody>
                                <tr>
                                    <td class="py-1 text-secondary" width="24%">Description</td>
                                    <td class="py-1 font-weight-bold">{{ qpr.description }}</td>
                                </tr>
                                <tr>
                                    <td class="py-1 text-secondary align-top" width="24%">Attachment</td>
                                    <td class="py-1 font-weight-bold align-top">
                                      <img
                                        class="img-fluid"
                                        :src="'data:image/*;base64,' + qpr.attachment_claim"
                                        v-if="qpr.attachment_claim" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                      </div>
                    </div>
                    <hr>
                    <div class="row mt-3">
                      <div class="col-md">
                        <div class="form-group">
                          <label class="text-sm font-weight-bold mb-1">1. Sorting the results of stock</label>
                          <textarea
                            v-model="qpr.sorting_result"
                            class="form-control mb-2"
                            id="exampleFormControlTextarea1"
                            rows="3"
                            :readonly="!edit"
                            required></textarea>
                        </div>
                        <div class="form-group">
                          <label class="text-sm font-weight-bold mb-1">2. Actual item survey</label>
                          <textarea
                            v-model="qpr.actual_item_survey"
                            class="form-control mb-2"
                            id="exampleFormControlTextarea1"
                            rows="3"
                            :readonly="!edit"
                            required></textarea>
                        </div>
                        <div class="form-group">
                          <label class="text-sm font-weight-bold mb-1">3. Process overview</label>
                          <textarea
                            v-model="qpr.process_overview"
                            class="form-control mb-2"
                            id="exampleFormControlTextarea1"
                            rows="3"
                            :readonly="!edit"
                            required></textarea>
                        </div>
                        <div class="d-flex justify-content-between">
                          <label class="text-sm font-weight-bold mb-1">4. Factorial Analysis</label>
                        </div>
                        <div class="table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <th class="text-xs w-2 text-center">#</th>
                              <th class="text-xs ps-2">Process</th>
                              <th class="text-xs ps-2">Decide events or survey content</th>
                              <th class="text-xs ps-2">Implementation status</th>
                              <th class="text-xs ps-2">Judge</th>
                              <th class="text-xs ps-2">Image</th>
                              <th class="text-xs ps-2">Type</th>
                              <th></th>
                            </thead>
                            <tbody>
                              <tr 
                                v-for="line,i in qpr.factorial_analysis_ids"
                                :key="line.id">
                                <td class="text-xs text-center">{{ i+1 }}</td>
                                <td class="text-xs">{{ line.process }}</td>
                                <td class="text-xs">{{ line.decide_event }}</td>
                                <td class="text-xs">{{ line.implementation_status }}</td>
                                <td class="text-xs">{{ line.judge }}</td>
                                <td class="text-xs">
                                  <img
                                    class="img-fluid"
                                    :src="'data:image/*;base64,' + line.attachment_factorial"
                                    v-if="line.attachment_factorial" />
                                </td>
                                <td :class="'text-xs ' + (line.type_file === 'occur' ? 'text-success' : 'text-info')">{{ line.type_file }}</td>
                                <td class="text-xs">
                                  <div v-if="edit" class="btn btn-xs btn-link text-danger m-0 p-0" @click="deleteFactorial(i)">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <button
                            type="button"
                            class="btn btn-xs p-0 btn-link"
                            data-bs-toggle="modal"
                            data-bs-target="#modalFactorial"
                            v-if="edit">
                            <i
                            class="fa fa-plus"
                            aria-hidden="true"></i>
                            Add</button>
                        <div class="d-flex justify-content-between">
                          <label class="text-sm font-weight-bold mb-1">5. 5 Whys</label>
                        </div>
                        <div class="table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <th class="text-xs w-2 text-center">#</th>
                              <th class="text-xs ps-2">Occur</th>
                              <th class="text-xs ps-2">Outflow</th>
                              <th class="text-xs ps-2">Type</th>
                              <th></th>
                            </thead>
                            <tbody>
                              <tr 
                                v-for="line,i in qpr.five_why_ids"
                                :key="line.id">
                                <td class="text-xs text-center">{{ i+1 }}</td>
                                <td class="text-xs">{{ line.occur }}</td>
                                <td class="text-xs">{{ line.outflow }}</td>
                                <td class="text-xs">{{ line.type_file }}</td>
                                <td class="text-xs">
                                  <div v-if="edit" class="btn btn-xs btn-link text-danger m-0 p-0" @click="deleteFiveWhy(i)">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <button
                            type="button"
                            class="btn btn-xs btn-link"
                            data-bs-toggle="modal"
                            data-bs-target="#modalFiveWhy"
                            v-if="edit">
                            <i
                            class="fa fa-plus"
                            aria-hidden="true"></i>
                            Add</button>
                        <div class="d-flex justify-content-between">
                          <label class="text-sm font-weight-bold mb-1">6. Cause and Measure</label>
                        </div>
                        <div class="table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <th class="text-xs w-2 text-center">#</th>
                              <th class="text-xs ps-2">Cause</th>
                              <th class="text-xs ps-2">Counter Measure</th>
                              <th class="text-xs ps-2">PIC</th>
                              <th class="text-xs ps-2">Due Date</th>
                              <th class="text-xs ps-2">Type</th>
                              <th></th>
                            </thead>
                            <tbody>
                              <tr 
                                v-for="line,i in qpr.cause_and_measures_ids"
                                :key="line.id">
                                <td class="text-xs text-center">{{ i+1 }}</td>
                                <td class="text-xs">{{ line.cause }}</td>
                                <td class="text-xs">{{ line.counter_measure }}</td>
                                <td class="text-xs">{{ line.pic }}</td>
                                <td class="text-xs">{{ line.due_date }}</td>
                                <td :class="'text-xs ' + (line.type_file === 'occur' ? 'text-success' : 'text-info')">{{ line.type_file }}</td>
                                <td class="text-xs">
                                  <div v-if="edit" class="btn btn-xs btn-link text-danger m-0 p-0" @click="deleteCause(i)">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <button
                            type="button"
                            class="btn btn-xs btn-link"
                            data-bs-toggle="modal"
                            data-bs-target="#modalCause"
                            v-if="edit">
                            <i
                            class="fa fa-plus"
                            aria-hidden="true"></i>
                            Add</button>
                        <div class="d-flex justify-content-between">
                          <label class="text-sm font-weight-bold mb-1">7. Pawl and horizontal development</label>
                        </div>
                        <div class="table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <th class="text-xs w-2 text-center">#</th>
                              <th class="text-xs ps-2">Content</th>
                              <th class="text-xs ps-2">PIC</th>
                              <th class="text-xs ps-2">Due Date</th>
                              <th class="text-xs ps-2">Type</th>
                              <th></th>
                            </thead>
                            <tbody>
                              <tr 
                                v-for="line,i in qpr.pawl_horizontal_ids"
                                :key="line.id">
                                <td class="text-xs text-center">{{ i+1 }}</td>
                                <td class="text-xs">{{ line.content }}</td>
                                <td class="text-xs">{{ line.pic }}</td>
                                <td class="text-xs">{{ line.due_date }}</td>
                                <td :class="'text-xs ' + (line.type_file === 'deployment' ? 'text-success' : 'text-info')">{{ line.type_file }}</td>
                                <td class="text-xs">
                                  <div v-if="edit" class="btn btn-xs btn-link text-danger m-0 p-0" @click="deletePawl(i)">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <button
                            type="button"
                            class="btn btn-xs btn-link"
                            data-bs-toggle="modal"
                            data-bs-target="#modalPawl"
                            v-if="edit">
                            <i
                            class="fa fa-plus"
                            aria-hidden="true"></i>
                            Add</button>
                      </div>
                    </div>
                </div>
              </form>
            </div>
        </div>
    </div>
  </div>
  <!-- MODAL -->
    <div class="modal fade" id="modalFactorial" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalFactorialLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title" id="modalFactorialLabel">Factorial Analysis</p>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="col-md">
              <label for="name">Process</label>
              <input v-model="modal.process" type="text" class="form-control">
            </div>
            <div class="col-md">
              <label for="name">Decide events or survey content</label>
              <input v-model="modal.decide_event" type="text" class="form-control">
            </div>
            <div class="col-md">
              <label for="name">Implementation Status</label>
              <input v-model="modal.implementation_status" type="text" class="form-control">
            </div>
            <div class="col-md">
              <label for="name">Judge</label>
              <input v-model="modal.judge" type="text" class="form-control">
            </div>
            <div class="col-md">
              <label for="attachment_factorial">Photo / Attachment</label>
              <input type="file" class="form-control" accept="image/*" @change="getFactorialAttachment">
            </div>
            <div class="col-md">
              <label for="type_file">Type</label>
              <div class="form-check">
                <input v-model="modal.type_file" class="form-check-input" type="radio" name="typeFileRadio" id="typeFileRadio1" value="occur">
                <label class="form-check-label text-xs" for="typeFileRadio1">
                  Occur
                </label>
              </div>
              <div class="form-check">
                <input v-model="modal.type_file" class="form-check-input" type="radio" name="typeFileRadio" id="typeFileRadio2" value="outflow">
                <label class="form-check-label text-xs" for="typeFileRadio2">
                  Outflow
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-xs btn-primary" @click="addFactorial">
              <!-- {{ indexPICEdited !== null ? 'Save' : 'Add' }} -->
              Save
            </button>
            <button ref="discardFactorial" type="button" class="btn btn-xs btn-outline-secondary" data-bs-dismiss="modal">Discard</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalCause" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalCauseLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title" id="modalCauseLabel">Cause and Measure</p>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="col-md">
              <label for="name">Cause</label>
              <input v-model="modal.cause" type="text" class="form-control">
            </div>
            <div class="col-md">
              <label for="name">Counter Measure</label>
              <input v-model="modal.counter_measure" type="text" class="form-control">
            </div>
            <div class="col-md">
              <label for="name">PIC</label>
              <input v-model="modal.pic" type="text" class="form-control">
            </div>
            <div class="col-md">
              <label for="name">Due Date</label>
              <Datepicker
                v-model="modal.due_date" 
                format="dd MMMM yyyy"
                required
                />
            </div>
            <div class="col-md">
              <label for="type_file">Type</label>
              <div class="form-check">
                <input v-model="modal.type_file" class="form-check-input" type="radio" name="typeFileRadio" id="typeFileRadio1" value="occur">
                <label class="form-check-label text-xs" for="typeFileRadio1">
                  Occur
                </label>
              </div>
              <div class="form-check">
                <input v-model="modal.type_file" class="form-check-input" type="radio" name="typeFileRadio" id="typeFileRadio2" value="outflow">
                <label class="form-check-label text-xs" for="typeFileRadio2">
                  Outflow
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-xs btn-primary" @click="addCause">
              <!-- {{ indexPICEdited !== null ? 'Save' : 'Add' }} -->
              Save
            </button>
            <button ref="discardCause" type="button" class="btn btn-xs btn-outline-secondary" data-bs-dismiss="modal">Discard</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalFiveWhy" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalFiveWhyLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title" id="modalFiveWhyLabel">Cause and Measure</p>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="col-md">
              <label for="name">Type</label>
              <select v-model="modal.type_file" class="form-select">
                <option selected value="" disabled>-Select-</option>
                <option value="Why1">Why 1</option>
                <option value="Why2">Why 2</option>
                <option value="Why3">Why 3</option>
                <option value="Why4">Why 4</option>
                <option value="cause">Cause</option>
              </select>
            </div>
            <div class="col-md">
              <label for="name">Occur</label>
              <input v-model="modal.occur" type="text" class="form-control">
            </div>
            <div class="col-md">
              <label for="name">Outflow</label>
              <input v-model="modal.outflow" type="text" class="form-control">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-xs btn-primary" @click="addFiveWhy">
              <!-- {{ indexPICEdited !== null ? 'Save' : 'Add' }} -->
              Save
            </button>
            <button ref="discardFiveWhy" type="button" class="btn btn-xs btn-outline-secondary" data-bs-dismiss="modal">Discard</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalPawl" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalPawlLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title" id="modalPawlLabel">Pawl and Horizontal Development</p>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="col-md">
              <label for="name">Content</label>
              <input v-model="modal.content" type="text" class="form-control">
            </div>
            <div class="col-md">
              <label for="name">PIC</label>
              <input v-model="modal.pic" type="text" class="form-control">
            </div>
            <div class="col-md">
              <label for="name">Due Date</label>
              <Datepicker
                v-model="modal.due_date" 
                format="dd MMMM yyyy"
                required
                />
            </div>
            <div class="col-md">
              <label for="type_file">Type</label>
              <div class="form-check">
                <input v-model="modal.type_file" class="form-check-input" type="radio" name="typeFileRadio" id="typeFileRadio1" value="pawl">
                <label class="form-check-label text-xs" for="typeFileRadio1">
                  Pawl
                </label>
              </div>
              <div class="form-check">
                <input v-model="modal.type_file" class="form-check-input" type="radio" name="typeFileRadio" id="typeFileRadio2" value="deployment">
                <label class="form-check-label text-xs" for="typeFileRadio2">
                  Deployment
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-xs btn-primary" @click="addPawl">
              <!-- {{ indexPICEdited !== null ? 'Save' : 'Add' }} -->
              Save
            </button>
            <button ref="discardPawl" type="button" class="btn btn-xs btn-outline-secondary" data-bs-dismiss="modal">Discard</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import ArgonBadge from "@/components/ArgonBadge.vue";
const endpoint = require("../router/endpoint");

export default {
  name: "qpr-detail",
  components: {
    ArgonBadge
  },
  data() {
    return {
      qpr: null,
      edit: false,
      loading: false,
      modal: {
        process: null,
        decide_event: null,
        implementation_status: null,
        judge: null,
        type_file: null,
        cause: null,
        counter_measure: null,
        pic: null,
        due_date: null,
        occur: null,
        outflow: null,
        content: null,
        attachment_factorial: null,
        attachment_factorial_filename: null
      }
    };
  },
  methods: {
    getQPRDetail() {
      this.loading = true;
      this.axios
        .post(
          endpoint.QPR_DETAIL,
          {
            qpr_id: this.$route.params.id,
            partner_id: localStorage.getItem("partner_id")
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.qpr = response.data.data;
            this.loading = false;
          } else {
            // sys error
            this.$notify({
              type: "warn",
              title: "Warning!",
              text: response.data.message
            });
            this.loading = false;
          }
        })
        .catch((e) => {
          this.$notify({
            type: "error",
            title: "Failed!",
            text: e.response.data.message
          });
          this.loading = false;
        });
    },
    getFactorialAttachment (event) {
      var file = event.target.files[0]
      const reader = new FileReader()
      reader.onload = e => { 
        this.modal.attachment_factorial = e.target.result.split(',')[1]
      }
      reader.readAsDataURL(file)
      this.modal.attachment_factorial_filename = event.target.files[0].name
    },
    confirm() {
      this.loading = true;
      const values = {
        qpr_id: this.$route.params.id,
        partner_id: localStorage.getItem("partner_id"),
        sorting_result: this.qpr.sorting_result,
        actual_item_survey: this.qpr.actual_item_survey,
        process_overview: this.qpr.process_overview,
        factorial_analysis_ids: this.qpr.factorial_analysis_ids,
        cause_and_measures_ids: this.qpr.cause_and_measures_ids,
        five_why_ids: this.qpr.five_why_ids,
        pawl_horizontal_ids: this.qpr.pawl_horizontal_ids,
      }
      this.axios
        .post(endpoint.QPR_CONFIRM, values, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        })
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.$notify({
              type: "success",
              title: "Voila!",
              text: "Successfully confirm!"
            });
            this.edit = false;
            this.loading = false;
            this.getQPRDetail();
          } else {
            // sys error
            this.$notify({
              type: "warn",
              title: "Warning!",
              text: response.data.message
            });
            this.loading = false;
          }
        })
        .catch((e) => {
          this.$notify({
            type: "error",
            title: "Failed!",
            text: e.response.data.message
          });
          this.loading = false;
        });
    },
    clearModalValues() {
      this.modal.process = null;
      this.modal.decide_event = null;
      this.modal.implementation_status = null;
      this.modal.judge = null;
      this.modal.type_file = null;
      this.modal.cause = null
      this.modal.counter_measure = null
      this.modal.pic = null
      this.modal.due_date = null
      this.modal.content = null
      this.modal.attachment_factorial = null
      this.modal.attachment_factorial_filename = null
    },
    deleteFactorial(index) {
      this.qpr.factorial_analysis_ids.splice(index,1)
    },
    addFactorial() {
      if (this.modal.type_file && this.modal.process && this.modal.decide_event && this.modal.implementation_status && this.modal.judge) { 
        const vals = {
          type_file: this.modal.type_file,
          process: this.modal.process,
          decide_event: this.modal.decide_event,
          implementation_status: this.modal.implementation_status,
          judge: this.modal.judge,
          attachment_factorial: this.modal.attachment_factorial,
          attachment_factorial_filename: this.modal.attachment_factorial_filename,
        };
        this.qpr.factorial_analysis_ids.push(vals);
        this.clearModalValues();
        this.$refs.discardFactorial.click();
      } else {
        this.$notify({
          type: 'warn',
          title: 'Warning',
          text: 'All field are required, please fill all the field!',
        });
      }
    },
    deleteCause(index) {
      this.qpr.cause_and_measures_ids.splice(index,1)
    },
    addCause() {
      if (this.modal.type_file && this.modal.pic && this.modal.counter_measure && this.modal.cause && this.modal.due_date){
        const month = this.modal.due_date.getMonth() >= 9 ? (this.modal.due_date.getMonth() + 1) : '0' + (this.modal.due_date.getMonth() + 1)
        const day = this.modal.due_date.getDate() < 10 ? ('0' + this.modal.due_date.getDate()) : this.modal.due_date.getDate()
        const vals = {
          type_file: this.modal.type_file,
          cause: this.modal.cause,
          counter_measure: this.modal.counter_measure,
          pic: this.modal.pic,
          due_date: this.modal.due_date.getFullYear() + '-' + month + '-' + day
        };
        this.qpr.cause_and_measures_ids.push(vals);
        this.clearModalValues();
        this.$refs.discardCause.click();
      } else {
        this.$notify({
          type: 'warn',
          title: 'Warning',
          text: 'All field are required, please fill all the field!',
        });
      }
    },
    deleteFiveWhy(index) {
      this.qpr.five_why_ids.splice(index,1)
    },
    addFiveWhy() {
      if (this.modal.type_file && (this.modal.occur || this.modal.outflow) ) { 
        const vals = {
          type_file: this.modal.type_file,
          occur: this.modal.occur,
          outflow: this.modal.outflow,
        };
        this.qpr.five_why_ids.push(vals);
        this.clearModalValues();
        this.$refs.discardFiveWhy.click();
      } else {
        this.$notify({
          type: 'warn',
          title: 'Warning',
          text: 'Type file, and Occur or Outflow are required!',
        });
      }
    },
    deletePawl(index) {
      this.qpr.pawl_horizontal_ids.splice(index,1)
    },
    addPawl() {
      if (this.modal.type_file && this.modal.content && this.modal.pic && this.modal.due_date) { 
        const month = this.modal.due_date.getMonth() >= 9 ? (this.modal.due_date.getMonth() + 1) : '0' + (this.modal.due_date.getMonth() + 1)
        const day = this.modal.due_date.getDate() < 10 ? ('0' + this.modal.due_date.getDate()) : this.modal.due_date.getDate()
        const vals = {
          type_file: this.modal.type_file,
          content: this.modal.content,
          pic: this.modal.pic,
          due_date: this.modal.due_date.getFullYear() + '-' + month + '-' + day
        };
        this.qpr.pawl_horizontal_ids.push(vals);
        this.clearModalValues();
        this.$refs.discardPawl.click();
      } else {
        this.$notify({
          type: 'warn',
          title: 'Warning',
          text: 'All field are required, please fill all the field!',
        });
      }
    },
    download () {
      this.loading = true
      this.axios
        .post(
          endpoint.DOWNLOAD,
          {
            res_id: this.$route.params.id,
            template_report: 'bh_sanko_quality.action_report_ng_qpr'
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            const linkSource = `data:application/pdf;base64,${response.data.data.file}`;
            const downloadLink = document.createElement("a");
            const fileName = this.qpr.name + ".pdf";
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false;
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message,
            });
        });
    }
  },
  mounted() {
    this.getQPRDetail();
  }
};
</script>

<style>

</style>